const resizeTextareaHeight = (element) => {
    let style = window.getComputedStyle(element);
    let padding = ['padding-top', 'padding-bottom'].map((key) => parseInt(style.getPropertyValue(key), 10)).reduce((prev, cur) => prev + cur);

    element.style.height = '1px';
    element.style.height = `${padding + element.scrollHeight}px`;
};

export default resizeTextareaHeight;